import React, { Component } from 'react';

import { inject, observer, PropTypes } from 'mobx-react';
import { UserPhoto } from 'modules/user';

import './HeaderUserBoxProfile.scss';

@inject('UserStore')
@observer
class HeaderUserBoxProfile extends Component {
  static propTypes = {
    UserStore: PropTypes.objectOrObservableObject
  };

  render() {
    const { pictureThumbUrl, name, email } = this.props.UserStore;

    return (
      <div className="box__profile">
        <UserPhoto
          className="header__user__photo"
          photo={pictureThumbUrl}
          name={name}
        />
        <div className="box__profile__user">
          <span className="box__profile__user__name">{name}</span>
          <span className="box__profile__user__email">{email}</span>
        </div>
      </div>
    );
  }
}

export default HeaderUserBoxProfile;
